import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsDesktop } from "@/hooks/useBreakpoint";
import { useGetEventByID, useGetEventsHistory } from "@/queries/useEvents";
import { categoryToLabel } from "@/utils/categoryHandler";
import { formatEventDate } from "@/utils/string";
import { Pagination } from "@opala-ds/react";
import { LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../ui/toast";
import { AlertCard } from "./alertCard";
import { AlertDetailsModal } from "./AlertDetailsModal";
import { AlertFilterDialog } from "./AlertFilterDialog";
import { PAGE_SIZE } from "./useAlertFilters";
const buildAlertDetails = (event, detail, isLoading) => {
    const placeholder = isLoading ? "Carregando..." : "Não informado";
    if (!detail) {
        return {
            id: event.id,
            category: event.categoria,
            subcategories: [],
            date: placeholder,
            time: placeholder,
            localObservado: placeholder,
            coordenadas: placeholder,
            anexos: [],
            observacao: placeholder,
        };
    }
    return {
        id: event.id,
        category: event.categoria,
        subcategories: detail.subcategorias,
        date: detail.dataEvento,
        time: detail.horaEvento,
        localObservado: [detail.bairro, detail.cidade].filter(Boolean).join(", ") ||
            "Não informado",
        coordenadas: `${Number(detail.latitude).toFixed(6)}, ${Number(detail.longitude).toFixed(6)}`,
        anexos: detail.anexos,
        observacao: detail.observacao ?? placeholder,
    };
};
export function AlertGrid({ page, selectedCategories, selectedDays, handlePageChange, draftCategories, setDraftCategories, draftDays, setDraftDays, isFilterDialogOpen, setIsFilterDialogOpen, cancelFilter, applyFilter, }) {
    const { showToast } = useToast();
    const isDesktop = useIsDesktop(768);
    const navigate = useNavigate();
    const [selectedAlert, setSelectedAlert] = useState(null);
    const { data: historyData, isLoading: isHistoryLoading, isError: isHistoryError, } = useGetEventsHistory(undefined, selectedCategories, undefined, selectedDays, page, PAGE_SIZE);
    const { data: eventDetail, isLoading: isDetailLoading } = useGetEventByID(selectedAlert?.id ?? 0, { enabled: !!selectedAlert });
    useEffect(() => {
        if (isHistoryError) {
            showToast("Erro ao carregar os eventos. Por favor, tente novamente mais tarde.", "error");
        }
    }, [isHistoryError, showToast]);
    if (isHistoryLoading) {
        return _jsx(LoaderCircle, { className: "absolute animate-spin" });
    }
    const events = historyData?.content ?? [];
    const totalPages = historyData?.totalPages ?? 0;
    const isEmpty = events.length === 0;
    return (_jsxs("div", { className: "flex flex-col gap-8 w-full", children: [_jsxs("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3", children: [_jsx(AlertFilterDialog, { open: isFilterDialogOpen, onOpenChange: setIsFilterDialogOpen, draftCategories: draftCategories, setDraftCategories: setDraftCategories, draftDays: draftDays, setDraftDays: setDraftDays, onCancel: cancelFilter, onConfirm: applyFilter }), isEmpty ? (_jsxs("div", { className: "col-span-full flex flex-col items-center justify-center gap-4 py-16", children: [_jsx("img", { src: `${process.env.PUBLIC_URL}/empty/empty-documents.png`, alt: "Nenhum registro encontrado", className: isDesktop ? "w-1/4 h-auto" : "w-2/3 h-auto max-w-xs" }), _jsx("span", { className: "font-semibold text-lg text-[#BFBFBF]", children: "Nenhum registro encontrado." })] })) : (events.map((event) => (_jsx(AlertCard, { alertId: event.id, alertName: categoryToLabel(event.categoria), icon: event.categoria, date: formatEventDate(event.createdAt), onView: () => setSelectedAlert(event), onEdit: () => navigate(`/editar/${event.id}`) }, event.id))))] }), totalPages > 1 && (_jsx("div", { className: "flex justify-center [&_button]:rounded-lg", id: "paginacao-historico-alertas", "data-testid": "alert-history-pagination", children: _jsx(Pagination, { totalPages: totalPages, currentPage: page + 1, onPageChange: handlePageChange }) })), _jsx(AlertDetailsModal, { isOpen: !!selectedAlert, onClose: () => setSelectedAlert(null), data: selectedAlert
                    ? buildAlertDetails(selectedAlert, eventDetail, isDetailLoading)
                    : null })] }));
}
